<template>
  <div class="notfound">
    <p class="notfound-title">Sorry! Maintenance now</p>
    <img class="notfound-img" src="../assets/img/nazuna-kouzi.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Maintenance',

  data() {
    return {
    }
  },

  methods: {
  }
}

</script>

<style scoped>

.notfound {
  background: #f3983b;
  height: 100vh;
  max-height: 100%;
  z-index: -1;
}

.notfound-img {
  width: 300px;
  height: auto;
  margin: 20px auto;
  display: block;
  -webkit-animation: fuwafuwa 3s ease infinite;
  animation: fuwafuwa 3s ease infinite;
}

.notfound-title {
  width: 80%;
  padding-top: 40px;
  margin: auto;
  text-align: center;
  font-size: 26px;
  color: #fff;
  font-weight: 800;
}

@keyframes fuwafuwa {
  0% { transform:translateY(0) }
  5% { transform:translateY(0) }
  10% { transform:translateY(0) }
  20% { transform:translateY(-15px) }
  25% { transform:translateY(0) }
  30% { transform:translateY(-15px) }
  50% { transform:translateY(0) }
  100% { transform:translateY(0) }
}

@media screen and (min-width: 600px){
}
</style>
